var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCombinedChargesEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38239 2.59022C9.87919 2.05197 10.1276 1.78285 10.3915 1.62587C11.0284 1.24709 11.8127 1.23531 12.4602 1.5948C12.7285 1.74379 12.9845 2.00533 13.4966 2.52843C14.0087 3.05152 14.2647 3.31307 14.4105 3.58721C14.7625 4.24867 14.7509 5.04978 14.3801 5.70039C14.2265 5.97003 13.963 6.22377 13.4361 6.73125L7.16699 12.7695C6.16851 13.7312 5.66925 14.2121 5.04529 14.4557C4.42133 14.6995 3.73539 14.6815 2.36349 14.6457L2.17684 14.6408C1.75919 14.6299 1.55037 14.6244 1.42898 14.4866C1.30759 14.3489 1.32416 14.1361 1.35731 13.7107L1.37531 13.4797C1.46859 12.2823 1.51523 11.6836 1.74906 11.1454C1.98288 10.6072 2.38621 10.1703 3.19287 9.29625L9.38239 2.59022Z",
    fill: "#3568FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66675 2.66675L13.3334 7.33341",
    stroke: "#F5F7F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 14.6667H14.6666",
    stroke: "#3568FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombinedChargesEdit);
export default __webpack_public_path__ + "static/media/combined_charges_edit.8de29c7bc640390cc92a53b69407f7f7.svg";
export { ForwardRef as ReactComponent };